export default __webpack_public_path__ + "static/media/starFavorisBlanc.207bb7d7.jpg";